import { ca } from '@cian/analytics';
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { TPageExtra } from '../../../types';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { getProducts } from '../../../utils/tracking/get_products';
import { ISoprProducts } from '../../../utils/tracking/types';

interface ITrackGetOnlineClick {
  offer: IOfferSchema;
  position: number;
  promo: IPromoInfo;
}

export function trackGetOnlineClick({ offer, position, promo }: ITrackGetOnlineClick) {
  const extra: Partial<TPageExtra> = {
    promoCianMortgage: promo.uniquePromoId,
    promoId: promo.promoId,
    position,
  };

  const { promoType } = promo;
  const products: ISoprProducts = getProducts({ agent: null, offer, kpId: null, extra });

  ca('eventSite', {
    action: 'click_get_online',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [products],
  });
}
